import React, { Fragment } from 'react';
import {
  HeaderDropdownContainer,
  HeaderDropdownIcon,
  DropdownOuterWrapper,
  // DropdownTitleWrapper,
  DropdownNavsWrapper,
  DropdownNavDiv,
  DropdownNavIcon,
  DropdownNavText,
  DropdownNavDescText,
} from './styles';
import { HeaderNavItem } from '../styles';
import productsData from '../../../../Data/productsData';

export default function HeaderDropdown({ productsDropdown, solutionsDropdown }) {
  return (
    <Fragment>
      {productsDropdown ? (
        <HeaderDropdownContainer>
          <HeaderNavItem style={{ marginRight: 'unset' }}>
            Products <HeaderDropdownIcon />
          </HeaderNavItem>
          <DropdownOuterWrapper>
            {/*<DropdownTitleWrapper>Products</DropdownTitleWrapper>*/}
            <DropdownNavsWrapper>
              {productsData.map(({ productID, productIcon, productDisplayName, productPageLink, productDesc }) => (
                <DropdownNavDiv key={productID} href={productPageLink}>
                  <DropdownNavIcon src={productIcon} alt="" />
                  <div>
                    <DropdownNavText>{productDisplayName}</DropdownNavText>
                    <DropdownNavDescText>{productDesc}</DropdownNavDescText>
                  </div>
                </DropdownNavDiv>
              ))}
            </DropdownNavsWrapper>
          </DropdownOuterWrapper>
        </HeaderDropdownContainer>
      ) : (
        <HeaderDropdownContainer>
          <HeaderNavItem>Solutions</HeaderNavItem>
          <DropdownOuterWrapper>
            {/*<DropdownTitleWrapper>Solutions</DropdownTitleWrapper>*/}
            <DropdownNavsWrapper>
              {productsData.map(({ productID, productIcon, productDisplayName, productPageLink, productDesc }) => (
                <DropdownNavDiv key={productID} href={productPageLink}>
                  <DropdownNavIcon src={productIcon} alt="" />
                  <div>
                    <DropdownNavText>{productDisplayName}</DropdownNavText>
                    <DropdownNavDescText>{productDesc}</DropdownNavDescText>
                  </div>
                </DropdownNavDiv>
              ))}
            </DropdownNavsWrapper>
          </DropdownOuterWrapper>
        </HeaderDropdownContainer>
      )}
    </Fragment>
  );
}
